import { post } from './client.js'
import { bridgeParams } from './sessions.js'
import { withFreshToken } from './tokenProvider.js'

/**
 * Submit a contact-sales lead. Auth params (scopedToken/apiUrl/projectCode)
 * come from the bridge store — the same values the endpoint authenticates
 * with, so only signed-in RDrive users can submit. The server enriches the
 * lead from the validated token (teamId/userId/host) and captures the gate
 * `reason` ("no_pool" | "exhausted") for sales context.
 *
 * Resolves to `{ ok: true, alreadySubmitted: bool }`.
 */
export function submitSalesContact(payload) {
  return withFreshToken(() => post(`/sales/contact?${bridgeParams()}`, payload))
}
